
jQuery(function($) {
$j('.njohn_product_grid_img_thumbs img').click(function(){
	ItemsEvents(this);
});

// IMAGE THUMBS SELECTOR AND MOUSEOVER
$j(".njohn_product_grid_img_thumbs img").hover(
	function () {
		ItemsEvents(this);
	}
);
  
  function ItemsEvents(data) {
      var myParent = $j(data).parent().parent().parent().parent().parent().parent().attr('nj-item-code');
      var src = $j(data).attr('image-data-large');
      var url = $j(data).attr('url-id');
      var id = $j(data).attr('id');
      $j('.njohn_product_grid_column[nj-item-code="'+myParent+'"] .'+ url).attr("src", src);

      if($j(data).hasClass('njohn_product_grid_img_thumbs_active') == false) {
          $j('.njohn_product_grid_column[nj-item-code="'+myParent+'"] .njohn_product_grid_img_thumbs img#' + id).removeClass('njohn_product_grid_img_thumbs_active');
          $j(data).addClass('njohn_product_grid_img_thumbs_active');
      }
  }
	
	$j(window).ready(function(){
		$j('.flexslider').flexslider({
			animation: "slide",
			itemWidth: 50,
			itemMargin: 5,
            animationLoop: true, // Infinity Next
            controlNav: false, // hide control navigator if 'false'
          	slideshow: false // disable auto play if 'false'
		});
	});
});
